
/**
document.addEventListener('DOMContentLoaded', function () {
  function initSliders() {
    var sliders = document.querySelectorAll('.plp-product-imgs-group.has-slider');
    sliders.forEach(function (slider) {
      if (!slider.flickityInstance) {
        slider.flickityInstance = new Flickity(slider, {
          cellAlign: 'left',
          contain: true,
          pageDots: true
        });
      }
    });
  }

  // Run after DOM is ready
  initSliders();

  // Optional: if elements load a bit later, run again after a short delay
  setTimeout(initSliders, 500);
});
**/





/*

function initSliders() {
    var sliders = document.querySelectorAll('div:not(#CollectionAjaxContent) .plp-product-imgs-group.has-slider:not(.flickity-enabled)');
    sliders.forEach(function (slider) {
        if (!slider.flickityInstance) {
        slider.flickityInstance = new Flickity(slider, {
            cellAlign: 'left',
            contain: true,
            pageDots: true
        });
        }
    });
}

// Run after DOM is ready
initSliders();

// Optional: if elements load a bit later, run again after a short delay
setTimeout(initSliders, 500);

*/













/**  
const fltrButtons = document.querySelectorAll('.collapsible-trigger-btn');

fltrButtons.forEach(button => {
  button.addEventListener('click', function (event) {
    const fltrItem = event.currentTarget.closest('.collection-sidebar__wrap');

    // Find all siblings of the current filter item
    const siblings = Array.from(fltrItem.parentNode.children).filter(
      child => child !== fltrItem
    );

    siblings.forEach(sib => {
      const sibBtn = sib.querySelector('.collapsible-trigger-btn');
      const sibOptsWrap = sib.querySelector('.collapsible-content');

      if (sibBtn && sibOptsWrap) {
        sibBtn.classList.remove('is-open');
        sibBtn.setAttribute('aria-expanded', 'false');
        sibOptsWrap.classList.remove('is-open');
        sibOptsWrap.style.height = '0px';
      }
    });
  });
});
**/







// function initSliders() {
//     var sliders = document.querySelectorAll('#CollectionAjaxContent .plp-product-imgs-group.has-slider:not(.flickity-enabled)');
//     sliders.forEach(function (slider) {
//         new Flickity(slider, {
//           cellAlign: 'left',
//           contain: true,
//           pageDots: true,
//           prevNextButtons: false,
//           draggable: true
//         });
//     });
// }


function initSliders() {
  document.querySelectorAll('.collection-grid__wrapper .plp-product-imgs-group.has-slider')
    .forEach(slider => {
      if (!slider.flickityInstance) {
        const flkty = new Flickity(slider, {
          cellAlign: 'left',
          contain: true,
          pageDots: true,
          prevNextButtons: false, // optional for PLP thumbnails
          draggable: true,
          imagesLoaded: true   // 👈 ensures layout waits for images
        });
        slider.flickityInstance = flkty;

        // 👇 Safety refresh when all images inside slider load
        const imgs = slider.querySelectorAll("img");
        let loadedCount = 0;
        imgs.forEach(img => {
          if (img.complete) {
            loadedCount++;
          } else {
            img.addEventListener("load", () => {
              loadedCount++;
              if (loadedCount === imgs.length) {
                flkty.resize();
              }
            });
            img.addEventListener("error", () => {
              loadedCount++;
              if (loadedCount === imgs.length) {
                flkty.resize();
              }
            });
          }
        });

        // If they were all already cached
        if (loadedCount === imgs.length) {
          flkty.resize();
        }
      }
    });
}

function destroyFlicktySlider() {
  return new Promise(resolve => {
    const sliders = document.querySelectorAll(".plp-product-imgs-group.has-slider");

    sliders.forEach(slider => {
      if (slider.flickityInstance) {
        slider.flickityInstance.destroy();
        slider.flickityInstance = null;
      }
    });

    resolve("destroyed");
  });
}

// Initial run after DOM is ready
document.addEventListener("DOMContentLoaded", function() {
  initSliders();
});

// On collection reload
document.addEventListener("collection:reloaded", function() {
  destroyFlicktySlider()
    .then(() => {
      initSliders();
    })
    .catch(err => console.error("Flickity reset failed:", err));
});




/*
(function () {
  function initMobileFilters() {
    if (window.innerWidth > 768) return; // Only mobile
    
    const topFilterWrapper = document.querySelector('.top-filter-wrapper');
    if (!topFilterWrapper || document.querySelector('.cp-mobile-fltrContent-wrapper')) return;
    
    // Create wrapper for cloned content
    const mobileWrapper = document.createElement('div');
    mobileWrapper.className = 'cp-mobile-fltrContent-wrapper';
    topFilterWrapper.insertAdjacentElement('afterend', mobileWrapper);
    
    // Clone all collapsible-content
    document.querySelectorAll('.filter-form .collapsible-content--sidebar').forEach(origContent => {
      const clone = origContent.cloneNode(true);
      clone.dataset.collapsibleId = origContent.dataset.collapsibleId; // ensure same id for match
      mobileWrapper.appendChild(clone);
      
      // Sync original -> clone
      origContent.querySelectorAll('input').forEach((input, idx) => {
        input.addEventListener('change', () => {
          const cloneInput = clone.querySelectorAll('input')[idx];
          if (cloneInput) {
            cloneInput.checked = input.checked;
            cloneInput.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      });
      
      // Sync clone -> original
      clone.querySelectorAll('input').forEach((input, idx) => {
        input.addEventListener('change', () => {
          const origInput = origContent.querySelectorAll('input')[idx];
          if (origInput) {
            origInput.checked = input.checked;
            origInput.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      });
    });

    // Click handler for collapsible-trigger-btn
    document.querySelectorAll('.collapsible-trigger-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        const id = btn.getAttribute('data-collapsible-id');
        const target = mobileWrapper.querySelector(`.collapsible-content--sidebar[data-collapsible-id="${id}"]`);
        
        if (target) {
          // Close others
          mobileWrapper.querySelectorAll('.collapsible-content--sidebar').forEach(el => {
            //if (el !== target) el.style.display = 'none';
            if (el !== target) el.classList.remove('is-open');
          });
          // Toggle clicked one
          //target.style.display = target.style.display === 'block' ? 'none' : 'block';
          
          // Toggle the clicked one
          target.classList.toggle('is-open');


          // Sync aria-expanded on the button
          const isOpen = target.classList.contains('is-open');
          btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');

        }
      });
    });
  }

  //document.addEventListener('DOMContentLoaded', initMobileFilters);
  initMobileFilters();
})();
*/


/** 
(() => {
  if (window.__CP_MOBILE_FILTERS__) return;
  window.__CP_MOBILE_FILTERS__ = true;

  document.addEventListener('DOMContentLoaded', function () {
    const MOBILE_MAX = 768;
    if (window.innerWidth > MOBILE_MAX) return;

    const topFilterWrapper = document.querySelector('.top-filter-wrapper');
    const mainForm = document.querySelector('.collection-sidebar .filter-form');
    if (!topFilterWrapper || !mainForm) return;

    // Create wrapper once
    let mobileWrapper = document.querySelector('.cp-mobile-fltrContent-wrapper');
    if (!mobileWrapper) {
      mobileWrapper = document.createElement('div');
      mobileWrapper.className = 'cp-mobile-fltrContent-wrapper';
      topFilterWrapper.insertAdjacentElement('afterend', mobileWrapper);
    }

    // Clone ONLY from the main (desktop) sidebar form
    const originalGroups = Array.from(
      mainForm.querySelectorAll('.collection-sidebar__group .collapsible-content--sidebar')
    );

    // Clear previous (if any re-init)
    mobileWrapper.innerHTML = '';

    originalGroups.forEach((orig) => {
      const id = orig.getAttribute('data-collapsible-id') || '';
      const clone = orig.cloneNode(true);
      clone.classList.add('cp-mobile-clone');
      clone.setAttribute('data-collapsible-id', id);
      clone.classList.remove('is-open');
      clone.style.display = 'none';
      mobileWrapper.appendChild(clone);
    });

    // Toggle: open the matching cloned panel on button click
    document.querySelectorAll('.collapsible-trigger-btn').forEach((btn) => {
      btn.addEventListener('click', () => {
        const id = btn.getAttribute('data-collapsible-id');
        if (!id) return;

        // Close others
        mobileWrapper.querySelectorAll('.collapsible-content--sidebar').forEach((el) => {
          if (el.dataset.collapsibleId !== id) {
            el.classList.remove('is-open');
            el.style.display = 'none';
          }
        });

        // Open/toggle target
        const target =
          mobileWrapper.querySelector(`.collapsible-content--sidebar[data-collapsible-id="${CSS?.escape?.(id) ?? id}"]`) ||
          mobileWrapper.querySelector(`.collapsible-content--sidebar[data-collapsible-id="${id}"]`);

        if (!target) return;
        const nowOpen = !target.classList.contains('is-open');
        target.classList.toggle('is-open', nowOpen);
        target.style.display = nowOpen ? 'block' : 'none';
        btn.setAttribute('aria-expanded', nowOpen ? 'true' : 'false');
      });
    });

    // ------ Sync (two-way) ------
    let syncing = false;

    function escAttr(v) {
      try { return CSS.escape(v); } catch (e) { return String(v).replace(/"/g, '\\"'); }
    }

    function findMatchingInput(container, src) {
      if (!src.name) return null;
      const nameSel = `input[name="${escAttr(src.name)}"]`;
      if (src.type === 'checkbox' || src.type === 'radio') {
        return container.querySelector(`${nameSel}[value="${escAttr(src.value)}"]`);
      }
      return container.querySelector(nameSel);
    }

    function mirrorInput(from, to) {
      if (!to || from === to) return;
      let changed = false;

      if (from.type === 'checkbox' || from.type === 'radio') {
        if (to.checked !== from.checked) {
          to.checked = from.checked;
          changed = true;
        }
      } else {
        if (to.value !== from.value) {
          to.value = from.value;
          changed = true;
        }
      }

      if (changed) {
        syncing = true;
        // Fire both events so theme logic reacts
        to.dispatchEvent(new Event('input', { bubbles: true }));
        to.dispatchEvent(new Event('change', { bubbles: true }));
        syncing = false;
      }
    }

    // Initial sync original -> clone
    originalGroups.forEach((orig) => {
      const id = orig.getAttribute('data-collapsible-id');
      const clone = mobileWrapper.querySelector(`.collapsible-content--sidebar[data-collapsible-id="${escAttr(id)}"]`)
        || mobileWrapper.querySelector(`.collapsible-content--sidebar[data-collapsible-id="${id}"]`);
      if (!clone) return;

      orig.querySelectorAll('input').forEach((inp) => {
        const match = findMatchingInput(clone, inp);
        mirrorInput(inp, match);
      });
    });

    // After you finish appending clones
    mobileWrapper.querySelectorAll('.price-range__slider').forEach((sliderEl) => {
      // Skip if already initialized
      if (sliderEl.noUiSlider) return;

      const priceWrap = sliderEl.closest('.price-range');
      if (!priceWrap) return;

      const min = parseFloat(priceWrap.dataset.min) || 0;
      const max = parseFloat(priceWrap.dataset.max) || 1000;

      const minInput = priceWrap.querySelector('.price-range__input-min');
      const maxInput = priceWrap.querySelector('.price-range__input-max');
      const minDisplay = priceWrap.querySelector('.price-range__display-min .money');
      const maxDisplay = priceWrap.querySelector('.price-range__display-max .money');

      // Init slider
      noUiSlider.create(sliderEl, {
        start: [
          parseFloat(minInput.value) || min,
          parseFloat(maxInput.value) || max,
        ],
        connect: true,
        step: 1,
        range: { min: min, max: max },
      });

      // Slider → inputs & displays
      sliderEl.noUiSlider.on('update', (values, handle) => {
        const value = Math.round(values[handle]);

        if (handle === 0) {
          minInput.value = value;
          if (minDisplay) minDisplay.textContent = `₹${value.toLocaleString()}`;
        } else {
          maxInput.value = value;
          if (maxDisplay) maxDisplay.textContent = `₹${value.toLocaleString()}`;
        }

        // Trigger events so syncing logic works
        const input = handle === 0 ? minInput : maxInput;
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });

      // Inputs → slider
      [minInput, maxInput].forEach((input, handle) => {
        input.addEventListener('change', () => {
          sliderEl.noUiSlider.setHandle(handle, input.value || 0);
        });
      });
    });

    // Live sync: mobile -> original
    mobileWrapper.addEventListener('change', (e) => {
      if (syncing) return;
      const src = e.target.closest('input');
      if (!src) return;

      const group = src.closest('.collapsible-content--sidebar');
      if (!group) return;

      const id = group.getAttribute('data-collapsible-id');
      const origGroup = mainForm.querySelector(`.collapsible-content--sidebar[data-collapsible-id="${escAttr(id)}"]`)
        || mainForm.querySelector(`.collapsible-content--sidebar[data-collapsible-id="${id}"]`);
      if (!origGroup) return;

      const twin = findMatchingInput(origGroup, src);
      mirrorInput(src, twin);
    });

    // Live sync: original -> mobile
    mainForm.addEventListener('change', (e) => {
      if (syncing) return;
      const src = e.target.closest('input');
      if (!src) return;

      const group = src.closest('.collapsible-content--sidebar');
      if (!group) return;

      const id = group.getAttribute('data-collapsible-id');
      const cloneGroup = mobileWrapper.querySelector(`.collapsible-content--sidebar[data-collapsible-id="${escAttr(id)}"]`)
        || mobileWrapper.querySelector(`.collapsible-content--sidebar[data-collapsible-id="${id}"]`);
      if (!cloneGroup) return;

      const twin = findMatchingInput(cloneGroup, src);
      mirrorInput(src, twin);
    });
  });
})();
**/


/*** 
(() => {
  if (window.__CP_MOBILE_FILTERS__) return;
  window.__CP_MOBILE_FILTERS__ = true;

  function initMobileFilters() {
    const MOBILE_MAX = 768;
    if (window.innerWidth > MOBILE_MAX) return;

    const topFilterWrapper = document.querySelector('.top-filter-wrapper');
    const mainForm = document.querySelector('.collection-sidebar .filter-form');
    if (!topFilterWrapper || !mainForm) return;

    // Create wrapper once
    let mobileWrapper = document.querySelector('.cp-mobile-fltrContent-wrapper');
    if (!mobileWrapper) {
      mobileWrapper = document.createElement('div');
      mobileWrapper.className = 'cp-mobile-fltrContent-wrapper';
      topFilterWrapper.insertAdjacentElement('afterend', mobileWrapper);
    }

    // Clone ONLY from the main (desktop) sidebar form
    const originalGroups = Array.from(
      mainForm.querySelectorAll('.collection-sidebar__group .collapsible-content--sidebar')
    );

    // Clear previous (if any re-init)
    mobileWrapper.innerHTML = '';

    originalGroups.forEach((orig) => {
      const id = orig.getAttribute('data-collapsible-id') || '';
      const clone = orig.cloneNode(true);
      clone.classList.add('cp-mobile-clone');
      clone.setAttribute('data-collapsible-id', id);
      clone.classList.remove('is-open');
      clone.style.display = 'none';
      mobileWrapper.appendChild(clone);
    });

    // Toggle: open the matching cloned panel on button click
    document.querySelectorAll('.collapsible-trigger-btn').forEach((btn) => {
      btn.addEventListener('click', () => {
        const id = btn.getAttribute('data-collapsible-id');
        if (!id) return;

        // Close others
        mobileWrapper.querySelectorAll('.collapsible-content--sidebar').forEach((el) => {
          if (el.dataset.collapsibleId !== id) {
            el.classList.remove('is-open');
            el.style.display = 'none';
          }
        });

        // Open/toggle target
        const target =
          mobileWrapper.querySelector(`.collapsible-content--sidebar[data-collapsible-id="${CSS?.escape?.(id) ?? id}"]`) ||
          mobileWrapper.querySelector(`.collapsible-content--sidebar[data-collapsible-id="${id}"]`);

        if (!target) return;
        const nowOpen = !target.classList.contains('is-open');
        target.classList.toggle('is-open', nowOpen);
        target.style.display = nowOpen ? 'block' : 'none';
        btn.setAttribute('aria-expanded', nowOpen ? 'true' : 'false');
      });
    });

    // ------ Sync (two-way) ------
    let syncing = false;

    function escAttr(v) {
      try { return CSS.escape(v); } catch (e) { return String(v).replace(/"/g, '\\"'); }
    }

    function findMatchingInput(container, src) {
      if (!src.name) return null;
      const nameSel = `input[name="${escAttr(src.name)}"]`;
      if (src.type === 'checkbox' || src.type === 'radio') {
        return container.querySelector(`${nameSel}[value="${escAttr(src.value)}"]`);
      }
      return container.querySelector(nameSel);
    }

    function mirrorInput(from, to) {
      if (!to || from === to) return;
      let changed = false;

      if (from.type === 'checkbox' || from.type === 'radio') {
        if (to.checked !== from.checked) {
          to.checked = from.checked;
          changed = true;
        }
      } else {
        if (to.value !== from.value) {
          to.value = from.value;
          changed = true;
        }
      }

      if (changed) {
        syncing = true;
        to.dispatchEvent(new Event('input', { bubbles: true }));
        to.dispatchEvent(new Event('change', { bubbles: true }));
        syncing = false;
      }
    }

    // Initial sync original -> clone
    originalGroups.forEach((orig) => {
      const id = orig.getAttribute('data-collapsible-id');
      const clone = mobileWrapper.querySelector(`.collapsible-content--sidebar[data-collapsible-id="${escAttr(id)}"]`)
        || mobileWrapper.querySelector(`.collapsible-content--sidebar[data-collapsible-id="${id}"]`);
      if (!clone) return;

      orig.querySelectorAll('input').forEach((inp) => {
        const match = findMatchingInput(clone, inp);
        mirrorInput(inp, match);
      });
    });
    


      mobileWrapper.querySelectorAll('.price-range__slider').forEach((sliderEl) => {
        if (sliderEl.noUiSlider) return;

        const priceWrap = sliderEl.closest('.price-range');
        if (!priceWrap) return;

        const min = parseFloat(priceWrap.dataset.min) || 0;
        const max = parseFloat(priceWrap.dataset.max) || 1000;

        const minInput = priceWrap.querySelector('.price-range__input-min');
        const maxInput = priceWrap.querySelector('.price-range__input-max');
        const minDisplay = priceWrap.querySelector('.price-range__display-min .money');
        const maxDisplay = priceWrap.querySelector('.price-range__display-max .money');

        noUiSlider.create(sliderEl, {
          start: [
            (minInput && parseFloat(minInput.value)) || min,
            (maxInput && parseFloat(maxInput.value)) || max,
          ],
          connect: true,
          step: 1,
          range: { min: min, max: max },
        });

        // Slider → Inputs + Displays
        sliderEl.noUiSlider.on('update', (values, handle) => {
          const value = Math.round(values[handle]);

          if (handle === 0) {
            if (minInput) minInput.value = value;
            if (minDisplay) minDisplay.textContent = `₹${value.toLocaleString()}`;
          } else {
            if (maxInput) maxInput.value = value;
            if (maxDisplay) maxDisplay.textContent = `₹${value.toLocaleString()}`;
          }

          const input = handle === 0 ? minInput : maxInput;
          if (input) {
            requestAnimationFrame(() => {
              setTimeout(() => {
                input.dispatchEvent(new Event('input', { bubbles: true }));
                input.dispatchEvent(new Event('change', { bubbles: true }));
              }, 0);
            });
          }
        });

        // Inputs → Slider
        [minInput, maxInput].forEach((input, handle) => {
          if (input) {
            input.addEventListener('change', () => {
              if (sliderEl.noUiSlider) {
                sliderEl.noUiSlider.setHandle(handle, input.value || 0);
              }
            });
          }
        });
      });



    // Live sync: mobile -> original
    mobileWrapper.addEventListener('change', (e) => {
      if (syncing) return;
      const src = e.target.closest('input');
      if (!src) return;

      const group = src.closest('.collapsible-content--sidebar');
      if (!group) return;

      const id = group.getAttribute('data-collapsible-id');
      const origGroup = mainForm.querySelector(`.collapsible-content--sidebar[data-collapsible-id="${escAttr(id)}"]`)
        || mainForm.querySelector(`.collapsible-content--sidebar[data-collapsible-id="${id}"]`);
      if (!origGroup) return;

      const twin = findMatchingInput(origGroup, src);
      mirrorInput(src, twin);
    });

    // Live sync: original -> mobile
    mainForm.addEventListener('change', (e) => {
      if (syncing) return;
      const src = e.target.closest('input');
      if (!src) return;

      const group = src.closest('.collapsible-content--sidebar');
      if (!group) return;

      const id = group.getAttribute('data-collapsible-id');
      const cloneGroup = mobileWrapper.querySelector(`.collapsible-content--sidebar[data-collapsible-id="${escAttr(id)}"]`)
        || mobileWrapper.querySelector(`.collapsible-content--sidebar[data-collapsible-id="${id}"]`);
      if (!cloneGroup) return;

      const twin = findMatchingInput(cloneGroup, src);
      mirrorInput(src, twin);
    });
  }

  // First run
  document.addEventListener('DOMContentLoaded', initMobileFilters);

  // Re-run after collection reload
  document.addEventListener('collection:reloaded', initMobileFilters);
})();))
***/


/****
(() => {
  if (window.__CP_MOBILE_FILTERS__) return;
  window.__CP_MOBILE_FILTERS__ = true;

  function initMobileFilters() {
    const MOBILE_MAX = 768;
    if (window.innerWidth > MOBILE_MAX) return;

    const topFilterWrapper = document.querySelector('.top-filter-wrapper');
    const mainForm = document.querySelector('.collection-sidebar .filter-form');
    if (!topFilterWrapper || !mainForm) return;

    // Create wrapper once
    let mobileWrapper = document.querySelector('.cp-mobile-fltrContent-wrapper');
    if (!mobileWrapper) {
      mobileWrapper = document.createElement('div');
      mobileWrapper.className = 'cp-mobile-fltrContent-wrapper';
      topFilterWrapper.insertAdjacentElement('afterend', mobileWrapper);
    }

    // Clone ONLY from the main (desktop) sidebar form
    const originalGroups = Array.from(
      mainForm.querySelectorAll('.collection-sidebar__group .collapsible-content--sidebar')
    );

    // Clear previous (if any re-init)
    mobileWrapper.innerHTML = '';

    originalGroups.forEach((orig) => {
      const id = orig.getAttribute('data-collapsible-id') || '';
      const clone = orig.cloneNode(true);
      clone.classList.add('cp-mobile-clone');
      clone.setAttribute('data-collapsible-id', id);
      clone.classList.remove('is-open');
      clone.style.display = 'none';
      mobileWrapper.appendChild(clone);
    });

    // Toggle: open the matching cloned panel on button click
    document.querySelectorAll('.collapsible-trigger-btn').forEach((btn) => {
      btn.addEventListener('click', () => {
        const id = btn.getAttribute('data-collapsible-id');
        if (!id) return;

        // Close others
        mobileWrapper.querySelectorAll('.collapsible-content--sidebar').forEach((el) => {
          if (el.dataset.collapsibleId !== id) {
            el.classList.remove('is-open');
            el.style.display = 'none';
          }
        });

        // Open/toggle target
        const target =
          mobileWrapper.querySelector(`.collapsible-content--sidebar[data-collapsible-id="${CSS?.escape?.(id) ?? id}"]`) ||
          mobileWrapper.querySelector(`.collapsible-content--sidebar[data-collapsible-id="${id}"]`);

        if (!target) return;
        const nowOpen = !target.classList.contains('is-open');
        target.classList.toggle('is-open', nowOpen);
        target.style.display = nowOpen ? 'block' : 'none';
        btn.setAttribute('aria-expanded', nowOpen ? 'true' : 'false');
      });
    });

    // ------ Sync (two-way inputs) ------
    let syncing = false;

    function escAttr(v) {
      try { return CSS.escape(v); } catch (e) { return String(v).replace(/"/g, '\\"'); }
    }

    function findMatchingInput(container, src) {
      if (!container || !src || !src.name) return null;
      const nameSel = `input[name="${escAttr(src.name)}"]`;
      if (src.type === 'checkbox' || src.type === 'radio') {
        return container.querySelector(`${nameSel}[value="${escAttr(src.value)}"]`);
      }
      return container.querySelector(nameSel);
    }

    function mirrorInput(from, to) {
      if (!to || from === to) return;
      let changed = false;

      if (from.type === 'checkbox' || from.type === 'radio') {
        if (to.checked !== from.checked) {
          to.checked = from.checked;
          changed = true;
        }
      } else {
        if (to.value !== from.value) {
          to.value = from.value;
          changed = true;
        }
      }

      if (changed) {
        syncing = true;
        try {
          to.dispatchEvent(new Event('input', { bubbles: true }));
          to.dispatchEvent(new Event('change', { bubbles: true }));
        } catch (e) {
          console.warn("Event dispatch failed:", e);
        }
        syncing = false;
      }
    }

    // Initial sync original -> clone
    originalGroups.forEach((orig) => {
      const id = orig.getAttribute('data-collapsible-id');
      const clone = mobileWrapper.querySelector(`.collapsible-content--sidebar[data-collapsible-id="${escAttr(id)}"]`)
        || mobileWrapper.querySelector(`.collapsible-content--sidebar[data-collapsible-id="${id}"]`);
      if (!clone) return;

      orig.querySelectorAll('input').forEach((inp) => {
        const match = findMatchingInput(clone, inp);
        mirrorInput(inp, match);
      });
    });

    
    // ===== Price Range Slider (Clone + Sync with Original) =====
    let isSyncingSlider = false;
    mobileWrapper.querySelectorAll('.price-range__slider').forEach((sliderEl) => {
      // 🔹 Destroy any old slider instance inside this element
      if (sliderEl.noUiSlider) {
        sliderEl.noUiSlider.destroy();
      }

      const priceWrap = sliderEl.closest('.price-range');
      if (!priceWrap) return;

      const min = parseFloat(priceWrap.dataset.min) || 0;
      const max = parseFloat(priceWrap.dataset.max) || 1000;

      const minInput = priceWrap.querySelector('.price-range__input-min') || null;
      const maxInput = priceWrap.querySelector('.price-range__input-max') || null;
      const minDisplay = priceWrap.querySelector('.price-range__display-min .money') || null;
      const maxDisplay = priceWrap.querySelector('.price-range__display-max .money') || null;

      // 🔹 Initialize slider fresh (will create one .noUi-base at the end)
      noUiSlider.create(sliderEl, {
        start: [
          (minInput && parseFloat(minInput.value)) || min,
          (maxInput && parseFloat(maxInput.value)) || max,
        ],
        connect: true,
        step: 1,
        range: { min: min, max: max },
      });

      // 🔹 Use the *last* noUi-base (safe for duplicated DOM)
      const allBases = sliderEl.querySelectorAll('.noUi-base');
      const activeBase = allBases[allBases.length - 1];

      // Slider → Inputs + Displays
      sliderEl.noUiSlider.on('update', (values, handle) => {
        const value = Math.round(values[handle]);

        if (handle === 0) {
          if (minInput) minInput.value = value;
          if (minDisplay) minDisplay.textContent = `₹${value.toLocaleString()}`;
        } else {
          if (maxInput) maxInput.value = value;
          if (maxDisplay) maxDisplay.textContent = `₹${value.toLocaleString()}`;
        }

        const input = handle === 0 ? minInput : maxInput;
        if (input) {
          requestAnimationFrame(() => {
            try {
              input.dispatchEvent(new Event('input', { bubbles: true }));
              input.dispatchEvent(new Event('change', { bubbles: true }));
            } catch (e) {}
          });
        }
      });

      // Inputs → Slider
      [minInput, maxInput].forEach((input, handle) => {
        if (input) {
          input.addEventListener('change', () => {
            if (sliderEl.noUiSlider) {
              sliderEl.noUiSlider.setHandle(handle, input.value || 0);
            }
          });
        }
      });

      // ==== NEW: Safe Sync with Original Slider ====
      const cloneGroup = sliderEl.closest('.collapsible-content--sidebar');
      if (cloneGroup) {
        const id = cloneGroup.getAttribute('data-collapsible-id');
        const origSlider = mainForm.querySelector(
          `.collapsible-content--sidebar[data-collapsible-id="${id}"] .price-range__slider`
        );

        if (origSlider && origSlider.noUiSlider) {
          // Clone → Original
          sliderEl.noUiSlider.on('set', (values) => {
            if (isSyncingSlider) return;
            isSyncingSlider = true;
            origSlider.noUiSlider.set(values);
            isSyncingSlider = false;
          });

          // Original → Clone
          origSlider.noUiSlider.on('set', (values) => {
            if (isSyncingSlider) return;
            isSyncingSlider = true;
            sliderEl.noUiSlider.set(values);
            isSyncingSlider = false;
          });
        }
      }
    });


    // Live sync: mobile -> original
    mobileWrapper.addEventListener('change', (e) => {
      if (syncing) return;
      const src = e.target.closest('input');
      if (!src) return;

      const group = src.closest('.collapsible-content--sidebar');
      if (!group) return;

      const id = group.getAttribute('data-collapsible-id');
      const origGroup = mainForm.querySelector(`.collapsible-content--sidebar[data-collapsible-id="${escAttr(id)}"]`)
        || mainForm.querySelector(`.collapsible-content--sidebar[data-collapsible-id="${id}"]`);
      if (!origGroup) return;

      const twin = findMatchingInput(origGroup, src);
      mirrorInput(src, twin);
    });

    // Live sync: original -> mobile
    mainForm.addEventListener('change', (e) => {
      if (syncing) return;
      const src = e.target.closest('input');
      if (!src) return;

      const group = src.closest('.collapsible-content--sidebar');
      if (!group) return;

      const id = group.getAttribute('data-collapsible-id');
      const cloneGroup = mobileWrapper.querySelector(`.collapsible-content--sidebar[data-collapsible-id="${escAttr(id)}"]`)
        || mobileWrapper.querySelector(`.collapsible-content--sidebar[data-collapsible-id="${id}"]`);
      if (!cloneGroup) return;

      const twin = findMatchingInput(cloneGroup, src);
      mirrorInput(src, twin);
    });
  }

  // First run
  document.addEventListener('DOMContentLoaded', initMobileFilters);
  // Re-run after collection reload
  document.addEventListener('collection:reloaded', initMobileFilters);
})();
****/



/*****

(() => {
  if (window.__CP_MOBILE_FILTERS__) return;
  window.__CP_MOBILE_FILTERS__ = true;

  function initMobileFilters() {
    const MOBILE_MAX = 768;
    if (window.innerWidth > MOBILE_MAX) return;

    const body = document.body;
    const triggers = document.querySelectorAll('.collapsible-trigger-btn');

    triggers.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.stopPropagation();
        const id = btn.getAttribute('data-collapsible-id');
        const panel = document.querySelector(
          `.collapsible-content--sidebar[data-collapsible-id="${id}"]`
        );
        if (!panel) return;

        const isOpen = panel.classList.contains('cp-open');

        // Close all open panels first
        document.querySelectorAll('.collapsible-content--sidebar.cp-open').forEach((el) => {
          el.classList.remove('cp-open');
          el.style.top = '';
          el.style.left = '';
        });
        body.classList.remove('cp-filter-open');

        if (!isOpen) {
          // Position panel relative to trigger
          const rect = btn.getBoundingClientRect();
          panel.style.position = 'fixed';
          panel.style.top = rect.bottom + window.scrollY + 'px';
          panel.style.left = rect.left + window.scrollX + 'px';
          panel.classList.add('cp-open');
          body.classList.add('cp-filter-open');
        }
      });
    });

    // Close when clicking outside
    document.addEventListener('click', (e) => {
      if (!body.classList.contains('cp-filter-open')) return;
      if (!e.target.closest('.collapsible-content--sidebar') && !e.target.closest('.collapsible-trigger-btn')) {
        closeAll();
      }
    });

    // Close when selecting an option
    document.querySelectorAll('.collapsible-content--sidebar input').forEach((input) => {
      input.addEventListener('change', () => {
        closeAll();
      });
    });

    function closeAll() {
      document.querySelectorAll('.collapsible-content--sidebar.cp-open').forEach((el) => {
        el.classList.remove('cp-open');
        el.style.top = '';
        el.style.left = '';
      });
      body.classList.remove('cp-filter-open');
    }
  }

  document.addEventListener('DOMContentLoaded', initMobileFilters);
  document.addEventListener('collection:reloaded', initMobileFilters);
})();

*****/



(() => {
  if (window.__CP_MOBILE_FILTERS__) return;
  window.__CP_MOBILE_FILTERS__ = true;

  function initMobileFilters() {
    const MOBILE_MAX = 768;
    if (window.innerWidth > MOBILE_MAX) return;

    const body = document.body;
    const topWrapper = document.querySelector('.top-filter-wrapper');
    const triggers = document.querySelectorAll('.collapsible-trigger-btn');
    let currentTopOffset = 0;

    // --- Recalculate top offset for fixed panel ---
    function updateTopOffset() {
      if (topWrapper) {
        const rect = topWrapper.getBoundingClientRect();
        const outerHeight = topWrapper.offsetHeight;
        // Since using fixed, don’t add window.scrollY
        currentTopOffset = rect.top + outerHeight / 2 + 20;
      }
    }
    updateTopOffset();

    // --- Close all panels ---
    function closeAll() {
      document.querySelectorAll('.collapsible-trigger-btn.is-open').forEach((el) => {
        el.classList.remove('is-open');
        el.setAttribute('aria-expanded', 'false');
      });
      document.querySelectorAll(
        '.collapsible-content--sidebar.is-open, .collapsible-content--sidebar.cp-open'
      ).forEach((el) => {
        el.classList.remove('cp-open', 'is-open');
        el.removeAttribute('style');
      });
      body.classList.remove('cp-filter-open');
    }

    // Update offset on scroll + resize
    window.addEventListener('scroll', updateTopOffset, { passive: true });
    window.addEventListener('resize', updateTopOffset);

    // --- Button click handler ---
    triggers.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.stopPropagation();
        const id = btn.getAttribute('data-collapsible-id');
        const panel = document.querySelector(
          `.collapsible-content--sidebar[data-collapsible-id="${id}"]`
        );
        if (!panel) return;

        const isOpen = panel.classList.contains('cp-open');
        closeAll();

        if (!isOpen) {
          const btnRect = btn.getBoundingClientRect();
          //panel.style.position = 'fixed';
          //panel.style.top = currentTopOffset + 'px';
          panel.style.left = (btnRect.left - 10) + 'px';
          panel.style.height = 'auto';

          btn.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');

          panel.classList.add('is-open', 'cp-open');
          body.classList.add('cp-filter-open');
        }
      });
    });

    // --- Close when clicking outside ---
    document.addEventListener('click', (e) => {
      if (!body.classList.contains('cp-filter-open')) return;
      if (
        !e.target.closest('.collapsible-content--sidebar') &&
        !e.target.closest('.collapsible-trigger-btn')
      ) {
        closeAll();
      }
    });

    // --- Close when selecting an option ---
    document.querySelectorAll('.collapsible-content--sidebar input').forEach((input) => {
      input.addEventListener('change', () => {
        closeAll();
      });
    });
  }

  // --- Remove all filter state ---
  function removeAllFilterFunctionality() {
    document.querySelectorAll('.collapsible-trigger-btn.is-open').forEach((el) => {
      el.classList.remove('is-open');
      el.setAttribute('aria-expanded', 'false');
    });
    document.querySelectorAll(
      '.collapsible-content--sidebar.is-open, .collapsible-content--sidebar.cp-open'
    ).forEach((el) => {
      el.classList.remove('cp-open', 'is-open');
      el.removeAttribute('style');
    });
    document.body.classList.remove('cp-filter-open');
  }

  // Init on DOM ready + after reload
  document.addEventListener('DOMContentLoaded', function() {
    setTimeout(initMobileFilters, 500);
  });
  document.addEventListener('collection:reloaded', () => {
    setTimeout(function() {
      initMobileFilters();
      removeAllFilterFunctionality();
    }, 500);
  });
})();








/**** Product Card Ratting Number ****/
document.addEventListener("DOMContentLoaded", function() {
  document.querySelectorAll('.grid-product__content').forEach(function(card) {
    const badge = card.querySelector('.jdgm-prev-badge');
    const wrapper = card.querySelector('.product-card__rating');

    if (badge && wrapper) {
      var score = badge.getAttribute('data-average-rating') || '5.0';
      if ( score == '0' || score == '0.00' ) {
        score = '5.0';
        wrapper.style.display = "none";
        wrapper.style.opacity = "0";
      } 
      else {
        score = parseFloat(score).toFixed(1);
      }
      wrapper.innerHTML = '<span class="jdgm-rating-score">' + score + '</span>';
    }
  });
});









// document.addEventListener('click', function (e) {
//   const fakeBtn = e.target.closest('.cp-card-actions .cp-qv-btn');
//   if (!fakeBtn) return;

//   e.preventDefault();

//   // Try closest .grid-product__content
//   let container = fakeBtn.closest('.grid-product__content');

//   // Fallback: .grid__item if .grid-product__content is missing
//   if (!container) {
//     container = fakeBtn.closest('.grid__item');
//   }

//   if (!container) return;

//   // Find the original quick view button inside the container
//   const origBtn = container.querySelector('.quick-product__btn');
//   if (origBtn) {
//     origBtn.click();
//   }
// });












/*
(() => {
  if (window.__CP_SYNC_FILTERS__) return;
  window.__CP_SYNC_FILTERS__ = true;

  function initDesktopSidebarClone() {
    if (window.innerWidth <= 767) return;

    const sidebar = document.querySelector("#CollectionSidebar");
    if (!sidebar) return;

    const originalRight = document.querySelector(".collection-grid__wrapper .cp-topfilters__right");
    const originalSort = document.querySelector(".collection-grid__wrapper .collection-filter__item--sort");

    let original = null;

    if (originalRight) {
      original = originalRight;
    } else if (originalSort) {
      original = originalSort;
    }

    if (!original) return;

    // --- Clone and append ---
    const clone = original.cloneNode(true);
    clone.classList.add("cp-cloned-filter"); // marker for future reference
    sidebar.appendChild(clone);

    // --- Hide originals ---
    if (originalRight) originalRight.style.display = "none";
    if (originalSort) originalSort.style.display = "none";

    // --- Sync changes ---
    const cloneSelect = clone.querySelector("select");
    const origSelect = original.querySelector("select");

    if (cloneSelect && origSelect) {
      // From clone -> original
      cloneSelect.addEventListener("change", () => {
        origSelect.value = cloneSelect.value;
        origSelect.dispatchEvent(new Event("change", { bubbles: true }));
      });

      // From original -> clone (in case changed programmatically)
      origSelect.addEventListener("change", () => {
        cloneSelect.value = origSelect.value;
      });
    }
  }

  document.addEventListener("DOMContentLoaded", initDesktopSidebarClone);
})();
*/



/**** Clone the exiting SORT filter label wrapper ****/
(() => {
  if (window.__CP_SYNC_FILTERS__) return;
  window.__CP_SYNC_FILTERS__ = true;

  function setupClone() {
    const sidebar = document.querySelector("#CollectionSidebar .top-filter-wrapper");
    if (!sidebar) return;

    // remove previous clone if exists
    const oldClone = sidebar.querySelector(".cp-cloned-filter");
    if (oldClone) oldClone.remove();

    const originalRight = document.querySelector(".collection-grid__wrapper .cp-topfilters__right");
    const originalSort = document.querySelector(".collection-grid__wrapper .collection-filter__item--sort");

    let original = null;

    if (originalRight) {
      original = originalRight;
    } else if (originalSort) {
      original = originalSort;
    }

    if (!original) return;

    // --- Clone and append ---
    const clone = original.cloneNode(true);
    clone.classList.add("cp-cloned-filter");
    sidebar.appendChild(clone);

    // --- Hide originals ---
    if (originalRight) originalRight.style.display = "none";
    if (originalSort) originalSort.style.display = "none";

    // --- Sync select values ---
    const cloneSelect = clone.querySelector("select");
    const origSelect = original.querySelector("select");

    if (cloneSelect && origSelect) {
      // clone → original
      cloneSelect.addEventListener("change", () => {
        origSelect.value = cloneSelect.value;
        origSelect.dispatchEvent(new Event("change", { bubbles: true }));
      });

      // original → clone
      origSelect.addEventListener("change", () => {
        cloneSelect.value = origSelect.value;
      });
    }
  }

  // run on load
  document.addEventListener("DOMContentLoaded", setupClone);

  document.addEventListener('collection:reloaded', setupClone);

  // also re-run on resize to handle desktop ↔ mobile switch
  window.addEventListener("resize", () => {
    setupClone();
  });
})();







// Utility: wait until element exists in DOM
function waitForElement(selector, callback, intervalTime = 100, timeout = 10000) {
  const startTime = Date.now();
  const interval = setInterval(() => {
    const el = document.querySelector(selector);
    if (el) {
      clearInterval(interval);
      callback(el);
    } else if (Date.now() - startTime > timeout) {
      clearInterval(interval);
      console.warn(`waitForElement: Timed out waiting for ${selector}`);
    }
  }, intervalTime);
}

// Usage
waitForElement('.whatmore-base', function(appSection) {
  const section = appSection.closest('.index-section');
  if (section) {
    section.classList.add('app-based-container');
  }
});
